import Const from '../const';
import createReducer from '../config/create_reducer';
import { userReducerHandler } from '../../../redux/user/user_reducer';

const getDefaultState = () => ({
  loading: false,
  user: null,
  error: null,
  emailDetails: {
    emailValidated: false,
    userChangeEmailAddress: false
  },
  nicknameDetails: {
    nickname: '',
    nicknameValidated: true,
    suggestedNickname: null
  },
  userMPIdentify: false
});

const handler = {
  ...userReducerHandler,
  [Const.wizard.payment.paymentProcessing]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
  [Const.user.nicknameChanged] : (state) => ({
    ...state,
    nicknameDetails: {
      ...state.nicknameDetails,
      error: null,
      nicknameValidated: false,
      suggestedNickname: null
    }
  }),
  [Const.user.nicknameSubmitted] : (state, { nickname }) => ({
    ...state,
    nicknameDetails: {
      ...state.nicknameDetails,
      nickname,
      nicknameValidated: true,
      error: null,
      suggestedNickname: null
    }
  }),
  [Const.user.nicknameValidated] : (state, { nickname }) => ({
    ...state,
    loading: false,
    nicknameDetails: {
      ...state.nicknameDetails,
      nickname,
      nicknameValidated: true,
      error: null,
      suggestedNickname: null
    }
  }),
  [Const.user.nicknameValidationError]: (state, { error, suggestedNickname }) => ({
    ...state,
    loading:false,
    nicknameDetails: {
      ...state.nicknameDetails,
      error,
      nicknameValidated: false,
      suggestedNickname
    }
  })
};

export default createReducer(getDefaultState(), handler);
